// src/league-routes.ts
var LEAGUE_MODULE_NAMES = /* @__PURE__ */ ((LEAGUE_MODULE_NAMES3) => {
  LEAGUE_MODULE_NAMES3["assessment"] = "assessment";
  LEAGUE_MODULE_NAMES3["appointmentBooking"] = "appointment-booking";
  LEAGUE_MODULE_NAMES3["careCollections"] = "care-collections";
  LEAGUE_MODULE_NAMES3["careDiscovery"] = "care-discovery";
  LEAGUE_MODULE_NAMES3["careDocuments"] = "care-documents";
  LEAGUE_MODULE_NAMES3["wallet"] = "wallet";
  LEAGUE_MODULE_NAMES3["healthJourney"] = "health-journey";
  LEAGUE_MODULE_NAMES3["healthJourneyHistory"] = "health-journey-history";
  LEAGUE_MODULE_NAMES3["healthNeedPages"] = "health-need-pages";
  LEAGUE_MODULE_NAMES3["healthProfile"] = "health-profile";
  LEAGUE_MODULE_NAMES3["healthPrograms"] = "health-programs";
  LEAGUE_MODULE_NAMES3["healthProgress"] = "health-progress";
  LEAGUE_MODULE_NAMES3["messaging"] = "messaging";
  LEAGUE_MODULE_NAMES3["onboarding"] = "onboarding";
  LEAGUE_MODULE_NAMES3["rewardsAchievements"] = "achievements";
  LEAGUE_MODULE_NAMES3["familyExperience"] = "family-experience";
  LEAGUE_MODULE_NAMES3["journeyManager"] = "journey-manager";
  LEAGUE_MODULE_NAMES3["aboutMe"] = "about-me";
  LEAGUE_MODULE_NAMES3["claims"] = "claims";
  LEAGUE_MODULE_NAMES3["customerSupport"] = "customer-support";
  LEAGUE_MODULE_NAMES3["contentAuthoring"] = "content-authoring";
  LEAGUE_MODULE_NAMES3["freRuleBuilder"] = "fre-rule-builder";
  LEAGUE_MODULE_NAMES3["serviceBooking"] = "service-booking";
  LEAGUE_MODULE_NAMES3["liveChat"] = "live-chat";
  LEAGUE_MODULE_NAMES3["freFlowBuilder"] = "fre-flow-builder";
  return LEAGUE_MODULE_NAMES3;
})(LEAGUE_MODULE_NAMES || {});
var leagueRoutesMap = {
  ["assessment" /* assessment */]: "/health-profile/questions",
  ["care-collections" /* careCollections */]: "/care-collections",
  ["care-discovery" /* careDiscovery */]: "/get-care",
  ["care-documents" /* careDocuments */]: "/care-documents",
  ["wallet" /* wallet */]: "/wallet",
  ["health-journey" /* healthJourney */]: "/health-journey",
  ["health-journey-history" /* healthJourneyHistory */]: "/health-history",
  ["health-need-pages" /* healthNeedPages */]: "/health-need",
  ["health-profile" /* healthProfile */]: "/health-profile",
  ["health-programs" /* healthPrograms */]: "/health-programs",
  ["health-progress" /* healthProgress */]: "/health-progress",
  ["messaging" /* messaging */]: "/messaging",
  ["onboarding" /* onboarding */]: "/onboarding",
  ["achievements" /* rewardsAchievements */]: "/achievements",
  ["family-experience" /* familyExperience */]: "/personal-care-team",
  ["journey-manager" /* journeyManager */]: "/family",
  ["about-me" /* aboutMe */]: "/about-me",
  ["claims" /* claims */]: "/claims",
  ["customer-support" /* customerSupport */]: "/customer-support",
  ["content-authoring" /* contentAuthoring */]: "/content-authoring",
  ["fre-rule-builder" /* freRuleBuilder */]: "/rule-builder",
  ["fre-flow-builder" /* freFlowBuilder */]: "/flow-builder",
  ["service-booking" /* serviceBooking */]: "/service-booking",
  ["live-chat" /* liveChat */]: "/live-chat",
  ["appointment-booking" /* appointmentBooking */]: "/appointment-booking"
};

// src/league-routes.util.ts
var checkModuleMapExists = (moduleName) => {
  if (!Object.keys(leagueRoutesMap).includes(moduleName))
    throw Error("Passed in module name has not been mapped to a path.");
};
var getModulePath = (moduleName) => {
  checkModuleMapExists(moduleName);
  return leagueRoutesMap[moduleName];
};
var setModulePath = (moduleName, path) => {
  checkModuleMapExists(moduleName);
  leagueRoutesMap[moduleName] = path;
};
var overwriteRoutePaths = (overrideRouteMap) => {
  Object.keys(overrideRouteMap).forEach((key) => {
    const moduleName = key;
    const value = overrideRouteMap[moduleName];
    if (value) {
      setModulePath(moduleName, value);
    }
  });
};
export {
  LEAGUE_MODULE_NAMES,
  getModulePath,
  leagueRoutesMap,
  overwriteRoutePaths,
  setModulePath
};
//# sourceMappingURL=index.js.map